import { Component, OnInit, Inject } from '@angular/core';
import { ActionModel } from '../action.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionsService } from '../actions.service';

@Component({
  selector: 'app-actions-view-tabs',
  templateUrl: './actions-view-tabs.component.html',
  styleUrls: ['./actions-view-tabs.component.scss']
})
export class ActionsViewTabsComponent implements OnInit {
  action: ActionModel = {} as ActionModel;
  is_edit: boolean = false;
  hide_asset_link: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { action: ActionModel; is_edit: boolean; hide_asset_link?: boolean },
    private actionsService: ActionsService
  ) {
    this.action = data.action;
    this.is_edit = data.is_edit;
    this.hide_asset_link = data.hide_asset_link ?? false;
  }

  ngOnInit() {
    if (this.data?.action?.id) {
      this.actionsService
        .find(this.data.action.id)
        .subscribe((res: any) => {
          // Use the fully loaded action (includes related assets, files, etc.)
          // for the view. Both the bound property and the dialog data are updated.
          this.action = res.data;
          this.data.action = res.data;
        });
    }
  }
}
